/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import { TimeFormat } from "../../../forms/elements/timeInputUtils";
import { EditableEffectiveDateRangeAccessRule } from "./effectiveDateRange";
import { EffectiveDateRangeRuleRow } from "./EffectiveDateRangeRuleRow";

type Props = {
  resources: Record<string, any>;
  season: string;
  dateFormat: string;
  timeFormat: TimeFormat;
  rules?: EditableEffectiveDateRangeAccessRule[];
  onChange: (rules: EditableEffectiveDateRangeAccessRule[]) => void;
  submitCount: number;
  hasChangesSinceSubmit: boolean;
  /** Which parts of the rule to show (bulk editor edits dates/time separately). */
  showDate?: boolean;
  showTime?: boolean;
  rootCss?: SerializedStyles;
};

/**
 * Currently only one EffectiveDateRangeAccessRule is permitted.
 * In the case where there are multiple effective date range rules,
 * the extra rules will be deleted during Save
 * in the parent component.
 */
export function EffectiveDateRangeAccessRuleEditor({
  resources,
  season,
  dateFormat,
  timeFormat,
  rules = [],
  onChange,
  submitCount,
  hasChangesSinceSubmit,
  showDate = true,
  showTime = true,
  rootCss,
}: Props) {
  const firstRule = rules[0];

  const handleFirstRuleChange = (
    updatedRule: EditableEffectiveDateRangeAccessRule | undefined,
  ) => {
    if (!updatedRule) {
      onChange([]);
      return;
    }

    onChange([updatedRule, ...rules.slice(1)]);
  };

  return (
    <div
      css={css`
        ${rootCss}
      `}
    >
      <EffectiveDateRangeRuleRow
        resources={resources}
        season={season}
        rule={firstRule}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        onChange={handleFirstRuleChange}
        submitCount={submitCount}
        hasChangesSinceSubmit={hasChangesSinceSubmit}
        showDate={showDate}
        showTime={showTime}
      />
    </div>
  );
}
